import * as React from 'react'

import { PlusOutlined } from '@ant-design/icons'
import { useState } from 'react'
import { Space, TablePaginationConfig } from 'antd'
import { FormattedMessage } from 'react-intl'
import { Tax, TaxesSearchRequest } from '.'
import AddTax from './modals/AddTax'
import EditTax from './modals/EditTax'
import DeleteTax from './modals/DeleteTax'
import ContributorButton from '../ContributorButton'
import { useTaxes } from './queries'
import { FittedTable, TableHeader } from '../styled'
import styled from 'styled-components'

const FlexedEnd = styled.div`
  display: flex;
  justify-content: flex-end;
`

const TaxRates = () => {
  const [req, setReq] = useState<TaxesSearchRequest>({
    page: 0,
    itemsPerPage: 10,
  })
  const taxesQuery = useTaxes(req)
  const onChangeHandler = ({ current, pageSize }: TablePaginationConfig) => {
    setReq(prev => ({
      page: !!current ? current - 1 : prev.page,
      itemsPerPage: pageSize ?? prev.itemsPerPage,
    }))
  }

  const [isModalVisible, setIsModalVisible] = useState(false)

  console.log(taxesQuery.data, {
    pageSize: req.itemsPerPage,
    current: req.page + 1,
    total: taxesQuery.data?.count ?? 0,
  })

  return (
    <FittedTable<Tax & { key: number }>
      size="middle"
      title={(): JSX.Element => (
        <TableHeader title={<FormattedMessage id="Tax_Card_Title" />}>
          <FlexedEnd>
            <ContributorButton
              type="primary"
              onClick={() => setIsModalVisible(true)}
            >
              <PlusOutlined />
              <FormattedMessage id="Tax_Add_Tax" />
            </ContributorButton>
            <AddTax
              visible={isModalVisible}
              onCancel={() => setIsModalVisible(false)}
            />
          </FlexedEnd>
        </TableHeader>
      )}
      dataSource={taxesQuery.data?.data?.map(d => ({ ...d, key: d.id }))}
      loading={taxesQuery.isLoading || taxesQuery.isFetching}
      pagination={{
        pageSize: req.itemsPerPage,
        current: req.page + 1,
        total: taxesQuery.data?.count ?? 0,
      }}
      columns={[
        {
          key: 'name',
          title: <FormattedMessage id="Tax_Name" />,
          dataIndex: 'name',
          width: '20%',
        },
        {
          key: 'rate',
          title: <FormattedMessage id="Tax_Rate" />,
          render: (_, record) =>
            `${Math.round(
              (record.rate.numerator / record.rate.denominator) * 100
            )} %`,
          width: '10%',
        },
        {
          key: 'desc',
          title: <FormattedMessage id="Tax_Description" />,
          render: (_, record) => record.description,
          width: '60%',
        },
        {
          key: 'action',
          title: <FormattedMessage id="Tax_Actions" />,
          render: (_, record) => (
            <Space size="middle">
              <EditTax {...record} />
              <DeleteTax id={record.id} name={record.name} />
            </Space>
          ),
        },
      ]}
      onChange={onChangeHandler}
    />
  )
}

export default TaxRates
